import RemoteCombo, { RemoteComboProps, configureSuggestStore } from "../../../components/form/RemoteCombo";
import { Tariff } from "../../../models/Types";

const cmd = 'TariffList';
const valueField = 'Name';

export const tariffStore = configureSuggestStore<Tariff>(cmd, valueField, 30 * 60, ['TariffSave']);

export default function TariffCombo({ ...props }: RemoteComboProps<Tariff>) {
    return <RemoteCombo<Tariff>
        store={tariffStore}
        typeId="Tariff"
        {...props} />;
}